module.exports = "/assets/827e0a5270fa2ba6482c515dd5b0942b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JA.png
// module id = 1503
// module chunks = 0